import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axios from "axios";
import { useMemo } from "react";

import { mergeImmigramFormConfig } from ".";

const EMPTY_OBJECT = {};
const EMPTY_ARRAY = [] as any[];

export function getApplicationFormConfig(
  applicationId: string,
  namespace: string
) {
  const baseUrl =
    typeof window === "undefined"
      ? process.env.NEXT_PUBLIC_APP_URL || "http://localhost:3000"
      : "";

  return axios
    .get(`${baseUrl}/api/application/${applicationId}/form/config`, {
      params: {
        namespace,
      },
    })
    .then((res) => res.data);
}

export function useApplicationFormConfig(
  applicationId: string,
  namespace: string | undefined,
  inputData: Record<string, string | null> = EMPTY_OBJECT,
  options: UseQueryOptions<any, any, any, any> = EMPTY_OBJECT
) {
  const {
    data: configs,
    isFetching,
    isInitialLoading,
  } = useQuery(
    ["application-form-config-query", namespace, applicationId],
    () =>
      applicationId && namespace
        ? getApplicationFormConfig(applicationId, namespace)
        : null,
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      enabled: !!namespace,
      ...options,
    }
  );

  return useMemo(() => {
    return {
      isFetching,
      isInitialLoading,
      config: configs
        ? mergeImmigramFormConfig(configs, inputData)
        : EMPTY_ARRAY,
    };
  }, [isFetching, isInitialLoading, configs, inputData]);
}
